import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getTheme } from '../ThemeProvider/theme';
import { useMediaQuery } from '@mui/material';

const useHeader = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const location = useLocation();
  const lang = location.pathname.substring(0, 3);

  const theme = getTheme('light');
  const mediumScreen = useMediaQuery(theme.breakpoints.down('md'));
  const largeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUserProfile = () => {
    navigate(`${lang}/profile?type=information`);
    setAnchorEl(null);
  };

  const handleLogout = () => {
    navigate(`${lang}/login`);
    localStorage.clear();
    setAnchorEl(null);
  };

  const handleRedirectTransfer = () => {
    navigate(`${lang}/transfer-page`);
  };
  const handleRedirectLastOperations = () => {
    navigate(`${lang}/last-operations`);
  };

  return {
    t,
    open,
    anchorEl,
    handleClick,
    handleClose,
    handleRedirectTransfer,
    handleRedirectLastOperations,
    mediumScreen,
    largeScreen,
    handleLogout,
    handleUserProfile,
  };
};

export default useHeader;
